import { http, config } from './__http';

export default {
    createPreOrder(sheet, params) {
        http.post(config.baseUrl()+'/PreOrder', params).then(response => {
            sheet(response.data);
        }).catch(e => {
            sheet(e.response);
        });
    },
    getPreOrders(sheets, params) {
        http.get(config.baseUrl()+'/PreOrder', params).then(response => {
            sheets(response.data);
        }).catch(e => {
            sheets(e.response);
        });
    },
    getPreOrderById(sheets, id) {
        http.get(config.baseUrl()+'/PreOrder/'+id).then(response => {
            sheets(response.data);
        }).catch(e => {
            sheets(e.response);
        });
    },
    getPreOrderTotalsById(sheets, id) {
      http.get(config.baseUrl()+'/PreOrder/'+id+'/totals').then(response => {
        sheets(response.data);
      }).catch(e => {
        sheets(e.response);
      });
    },
    getPreOrderNotificationsById(sheets, id) {
      http.get(config.baseUrl()+'/PreOrder/'+id+'/notifications').then(response => {
        sheets(response.data);
      }).catch(e => {
        sheets(e.response);
      });
    },
    getPreOrderProductsById(sheets, params) {
      http.get(config.baseUrl()+'/PreOrder/'+params.id+'/productgroups', { params: params.body }).then(response => {
        sheets(response.data);
      }).catch(e => {
        sheets(e.response);
      });
    },
    getPreOrderMarketingProductsById(sheets, params) {
      http.get(config.baseUrl()+'/PreOrder/'+params.id+'/marketingproductgroups', { params: params.body }).then(response => {
        sheets(response.data);
      }).catch(e => {
        sheets(e.response);
      });
    },
    updatePreOrderCustomer(sheets, params) {
        http.put(config.baseUrl()+'/PreOrder/'+params.PreOrderId+'/customer', params.body ).then(response => {
            sheets(response.data);
        }).catch(e => {
            sheets(e.response);
        });
    },
    updatePreOrderSalesman(sheets, params) {
        http.put( config.baseUrl()+'/PreOrder/'+params.PreOrderId+'/sales', params.body ).then(response => {
            sheets(response.data);
        }).catch(e => {
            sheets(e.response);
        });
    },
    closePreOrderById(sheets, params) {
        http.put(config.baseUrl()+'/PreOrder/'+params.preOrderId+'/close', params.body ).then(response => {
            sheets(response.data);
        }).catch(e => {
            sheets(e.response);
        });
    },

    // FORECASTED
    getPreOrdersForecasted(sheets, params) {
        http.get(config.baseUrl()+'/PreOrder/forecasted', params).then(response => {
            sheets(response.data);
        }).catch(e => {
            console.error(e);
        });
    },

    // CLOSED PRE-ORDERS
    getClosedPreOrders(sheets, params) {
        params.params.States = "3" //filter on closed pre-orders
        http.get(config.baseUrl()+'/PreOrder', params).then(response => {
            sheets(response.data);
        }).catch(e => {
            console.error(e);
        });
    },

    // NOTIFICATIONS
    updatePreOrderNotification(sheet, params) {
        http.put(config.baseUrl()+'/PreOrder/'+params.preOrderId+'/productnotification/'+params.notificationId, params.body ).then(response => {
            sheet(response.data);
        }).catch(e => {
            console.error(e);
        });
    },

    // PRODUCT GROUP
    updatePreOrderGroup(sheet, params) {
        http.put(config.baseUrl()+'/PreOrder/'+params.preOrderId+'/productgroup/'+params.productGroupId, params.body ).then(response => {
            sheet(response.data);
        }).catch(e => {
            console.error(e);
        });
    },

    // PRODUCT
    updatePreOrderProduct(sheet, params) {
        http.put(config.baseUrl()+'/PreOrder/'+params.preOrderId+'/product/'+params.productId, params.body ).then(response => {
            sheet(response.data);
        }).catch(e => {
            console.error(e);
        });
    },

    // PRODUCT VARIANTS
    updatePreOrderProductVariant(sheet, params) {
        http.put(config.baseUrl()+'/PreOrder/'+params.preOrderId+'/productvariant/'+params.productVariantId, params.body ).then(response => {
            sheet(response.data);
        }).catch(e => {
            console.error(e);
        });
    },

    // CUSTOMERS
    getCustomers(customers, params) {
        http.get(config.baseUrl()+'/customer', params).then(response => {
            customers(response.data);
        }).catch(e => {
            console.error(e);
        });
    },
    getCustomerById(customer, id) {
        http.get(config.baseUrl()+'/customer/'+id).then(response => {
            customer(response.data);
        }).catch(e => {
            console.error(e);
        });
    },
    updateCustomerById(customer, params) {
        http.put(config.baseUrl()+'/customer/', params.body).then(response => {
            customer(response.data);
        }).catch(e => {
            console.error(e);
        });
    },
    blockCustomerUser(user, params) {
        http.post(config.baseUrl()+'/customer/'+params.id+'/user/'+params.userId+'/block', params.body).then(response => {
            user(response.data);
        }).catch(e => {
            console.error(e);
        });
    },
    getCustomerSearch(sheets, params) {
        http.get(config.baseUrl()+'/customer/autocomplete', params).then(response => {
            sheets(response.data);
        }).catch(e => {
            console.error(e);
        });
    },
    getCustomerUsers(sheets, id) {
        http.get(config.baseUrl()+'/customer/'+id+'/user').then(response => {
            sheets(response.data);
        }).catch(e => {
            console.error(e);
        });
    },
    getCustomerAddress(sheets, id) {
        http.get(config.baseUrl()+'/customer/'+id+'/deliveryaddress').then(response => {
            sheets(response.data);
        }).catch(e => {
            console.error(e);
        });
    },
    addCustomerUser(user, params) {
        http.post(config.baseUrl()+'/customer/'+params.id+'/user', params.body).then(response => {
            user(response.data);
        }).catch(e => {
            user(e.response);
        });
    },

    // MARKETING PRODUCT GROUP
    updatePreOrderMarketingGroup(sheet, params) {
        http.put(config.baseUrl()+'/PreOrder/'+params.preOrderId+'/marketingproductgroup/'+params.productGroupId, params.body ).then(response => {
            sheet(response.data);
        }).catch(e => {
            console.error(e);
        });
    },

    // MARKETING PRODUCT
    updatePreOrderMarketingProduct(sheet, params) {
        http.put(config.baseUrl()+'/PreOrder/'+params.preOrderId+'/marketingproduct/'+params.productId, params.body ).then(response => {
            sheet(response.data);
        }).catch(e => {
            console.error(e);
        });
    },

    // MARKETING PRODUCT VARIANTS
    updatePreOrderMarketingProductVariant(sheet, params) {
        http.put(config.baseUrl()+'/PreOrder/'+params.preOrderId+'/marketingproductvariant/'+params.productVariantId, params.body ).then(response => {
            sheet(response.data);
        }).catch(e => {
            console.error(e);
        });
    },

    // SUBGROUP TOTALS
    getPreOrderSubGroupTotals(preorder, id) {
        http.get(config.baseUrl()+'/PreOrder/'+id+'/subgrouptotals').then(response => {
            preorder(response.data);
        }).catch(e => {
            console.error(e);
        });
    },

    // DELIVERY MOMENT TOTALS
    getPreOrderDeliveryMomentTotals(preorder, id) {
        http.get(config.baseUrl()+'/PreOrder/'+id+'/deliverymomenttotals').then(response => {
            preorder(response.data);
        }).catch(e => {
            console.error(e);
        });
    },

    // TARGETS AND TOTALS
    getPreOrderTargetsAndTotals(preorder, id) {
        http.get(config.baseUrl()+'/PreOrder/'+id+'/targets').then(response => {
            preorder(response.data);
        }).catch(e => {
            console.error(e);
        });
    },

    // SEND REMINDERS
    sendRemindersPreOrderById(preorder, params) {
        http.put(config.baseUrl()+'/PreOrder/'+params.preOrderId+'/sendreminders', params.body ).then(response => {
            preorder(response.data);
        }).catch(e => {
            console.error(e);
        });
    },

    // SEND PREORDER TO SALES
    sendToSales(preorder, id) {
        http.put(config.baseUrl()+'/PreOrder/'+id+'/sendtosales', null ).then(response => {
            preorder(response.data);
        }).catch(e => {
            console.error(e);
        });
    },

    // AX WARNINGS
    getAXWarnings(warnings, params) {
        http.get(config.baseUrl()+'/axwarning', params).then(response => {
            warnings(response.data);
        }).catch(e => {
            console.error(e);
        });
    },

    ignoreAXWarning(warning, id) {
        http.delete(config.baseUrl()+'/axwarning/'+id, null ).then(response => {
            warning(response.data);
        }).catch(e => {
            console.error(e);
        });
    },

    exportToCSV(warning, id) {
        http.post(config.baseUrl()+'/axwarning/'+id+'/export', null).then(response => {
            warning(response.data);
        }).catch(e => {
            console.error(e);
        })
    },

    exportPreOrderToCSV(preOrder, id) {
        http.post(config.baseUrl()+'/PreOrder/'+id+'/export', null).then(response => {
            preOrder(response.data);
        }).catch(e => {
            console.error(e);
        })
    },

    resendToAX(warning, id) {
        http.post(config.baseUrl()+'/axwarning/'+id+'/resend', null).then(response => {
            warning(response.data);
        }).catch(e => {
            console.error(e);
        })
    },

    resendPreOrderToAX(preOrder, id) {
        http.post(config.baseUrl()+'/PreOrder/'+id+'/resend', null).then(response => {
            preOrder(response.data);
        }).catch(e => {
            console.error(e);
        })
    }
}



// WEBPACK FOOTER //
// ./src/api/PreOrders.js